<template>
    <BCard>
        <ValidationObserver ref="form">
            <BForm @submit.prevent="onSubmit">
                <BRow class="mb-2">
                    <BCol cols="12" md="4"> <h3><b>Datos generales</b></h3> </BCol>
                </BRow>
                <BRow>
                    <TextInputValidated vsName="Name" :vsModel.sync="provider.name" vsLabel="name" vsMd="6" vsRequired vsRules="required" />
                    <TextInputValidated vsName="CIF" :vsModel.sync="provider.CIF" vsLabel="CIF" vsMd="6" vsRequired vsRules="required" />
                    <TextInputValidated vsName="Postal code" :vsModel.sync="provider.postal_code" vsLabel="postal_code" vsMd="6" />
                    <TextInputValidated vsName="Address" :vsModel.sync="provider.address" vsLabel="address" vsMd="6" />
                    <VSelectValidated vsName="Country" :vsModel.sync="provider.country_id" :vsOptions="countries" :vsReduce="country=> country.id" vsLabel="name" vsMd="6" vsRequired vsRules="required" />
                    <TextInputValidated vsName="City" :vsModel.sync="provider.city" vsLabel="city" vsMd="6" />
                </BRow>
                <BRow class="mt-3 mb-2">
                    <BCol cols="12" md="4"> <h3><b>Datos de contacto</b></h3> </BCol>
                </BRow>
                <BRow>
                    <TextInputValidated vsName="Email" :vsModel.sync="provider.email" vsLabel="email" vsMd="6" vsRequired vsRules="required" />
                    <TextInputValidated vsName="Phone" :vsModel.sync="provider.phone" vsLabel="phone" vsMd="6" />
                    <TextareaValidated  vsName="Notes" :vsModel.sync="provider.notes"/>
                </BRow>
                <BRow class="mt-3 mb-2">
                    <BCol cols="12" md="4"> <h3><b>Datos bancarios</b></h3> </BCol>
                </BRow>
                <BRow>
                    <TextInputValidated vsName="IBAN" :vsModel.sync="provider.IBAN" vsLabel="IBAN" vsMd="6" />
                    <TextInputValidated vsName="SWIFT" :vsModel.sync="provider.SWIFT" vsLabel="SWIFT" vsMd="6" />
                </BRow>
                <BRow class="mt-3 mb-2">
                    <BCol cols="12" md="4"> <h3><b>Preferencias</b></h3> </BCol>
                </BRow>
                <BRow>
                    <NumberInputValidated vsName="Equivalence surcharge" :vsModel.sync="provider.equivalence_surcharge" vsStep="0.01" vsMd="6" />
                    <VSelectValidated vsName="Payment method" :vsModel.sync="provider.payment_method" :vsOptions="payment_methods" vsLabel="name" vsMd="6" />
                    <DatepickerValidated vsName="End date" :vsModel.sync="provider.end_date" vsMd="6" /> 
                    <!-- ! TODO: Concretar que se hace con el campo "end_date" -->
                </BRow>
                <BRow class="mt-3 mb-2">
                    <BCol cols="12" md="4"> <h3><b>Datos adicionales</b></h3> </BCol>
                </BRow>
                <BRow>
                    <CheckboxValidated vsName="status" :vsModel.sync="provider.status" vsLabel="Proveedor activo" />
                </BRow>
                <BRow class="mt-3">
                    <BCol cols="12" md="4" >
                        <BButton variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
                        <BButton variant="outline-secondary" type="reset" :to="{ name:'providers' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{ $t('Cancel') }} </BButton>
                    </BCol>
                </BRow>
            </BForm>
        </ValidationObserver>
    </BCard>
</template>

<script>
import { ref } from '@vue/composition-api'
import { BButton, BCard, BCol, BForm, BRow } from 'bootstrap-vue';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import TextareaValidated from '@/components/forms/TextareaValidated.vue';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue';
import VSelectValidated from '@/components/forms/vSelectValidated.vue';
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue';
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue';
import { ValidationObserver } from 'vee-validate'
import axios from '@axios';
import router from '@/router';
export default {
    components: { BForm, BRow, TextInputValidated, BCard, BCol, BButton, TextareaValidated, NumberInputValidated, VSelectValidated, ValidationObserver, DatepickerValidated, CheckboxValidated },
    setup() {
        const form = ref(null);
        const countries = ref([])
        const payment_methods = ref([])
        const provider = ref([])
        
        const onSubmit = function(){
            form.value.validate().then(success => {
                if(success){
                    axios.put(`providers/${provider.value.id}`, provider.value)
                        .then(response => { router.push({ name: 'providers' }) })
                        .catch(error => errorToast('Error al añadir el proveedor'))
                }
            })
        }

        axios.get(`providers/${router.currentRoute.params.id}`).then(response => {
            provider.value = response.data
            provider.value.status == 1 ? provider.value.status = true : provider.value.status = false
        })

        axios.get('countries').then(response => {
            countries.value = response.data
        })

        axios.get('payment-methods').then(response => {
            payment_methods.value = response.data
        })

        return {
            onSubmit,
            form,
            countries,
            payment_methods,
            provider
        }
    },
}
</script>

<style>

</style>